<template>
  <div name="1">
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-wifi</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.wifi') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <!-- <v-divider vertical  style="margin: 0 10px 0 10px;"/> -->
    </v-toolbar>
    <translate
      v-show="!collapseContent"
      v-model="content.WifiName"
      :languages="languages"
      :label="$t('wifi.name')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <table v-show="!collapseContent">
      <tr>
        <td style="padding-top: 20px;">
          {{$t('wifi.wpa')}}
        </td>
        <td style="padding-left: 20px;padding-right: 20px;">
          <v-switch
            v-show="!collapseContent"
            v-model="content.WifiIsWep"
            :color="enterpriseColor"
            hide-details
            @change="handleChangeIsModified"
          />
        </td>
        <td style="padding-top: 20px;">
          {{$t('wifi.wep')}}
        </td>
      </tr>
    </table>
    <v-text-field
      v-show="!collapseContent"
      v-model="content.WifiSSID"
      :label="$t('wifi.ssid')"
      hideDetails
      @input="handleChangeIsModified"
    />
    <v-text-field
      v-show="!collapseContent"
      v-model="content.WifiPassword"
      :label="$t('wifi.password')"
      hideDetails
      @input="handleChangeIsModified"
    />
    <br v-show="!collapseContent">
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import Translate from '@/components/Translate'
  export default {
    components: {
      Translate
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      languages () {
        return this.$store.state.app.Languages
      }
    },
    mounted() {
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      }
    }
  }
</script>

<style scoped>
</style>

